<template>
	<div class="content">
		<section
			id="hero"
			class="container-expanded container band"
		>
			<h1>Restoring Teaching</h1>
			<p>Adam Voigt’s Restoring Teaching is now available in hard copy, eBook and audiobook</p>
		</section>

		<section
			id="book"
			class="cols container-expanded container-no-pad"
		>
			<div class="col col-6">
				<div class="col-inner col-center col-center-vert">
					<img
						:src="bookImage"
						alt="Restoring Teaching 2.0 book cover"
					/>
				</div>
			</div>
			<div
				id="book-details"
				class="col col-6"
			>
				<div class="col-inner col-center-vert">
					<h2>How working restoratively unleashes the teacher within</h2>
					<h3>By Adam Voigt</h3>
					<p>Building on his Restorative Practice “RP2.0” methodology, this edition includes practical resources and templates for educators developed by Adam, alongside his practical, no-nonsense advice to help you implement restoratives practice in your classroom.</p>
				</div>
			</div>
		</section>

		<section
			id="quote"
			class="container-expanded container cols band"
		>
			<div class="col col-2" />
			<div class="col col-center text-center">
				<h3>‘This book should be the first every aspiring and new school leader and teacher reads, the refresher book re-read before the start of the school year, and the go-to book when school life feels like a bowl of prunes.’</h3>
				<h4>Emeritus Laureate Professor John Hattie</h4>
			</div>
			<div class="col col-2" />
		</section>

		<section
			id="options"
			class="container-expanded container band"
		>
			<div class="cols">
				<div class="col col-12 text-center">
					<h2>Access to Restoring Teaching for partner schools</h2>
				</div>
			</div>
			<div class="cols">
				<div class="col col-4">
					<h4>Free eBook</h4>
					<p>Restoring Teaching is available as a free eBook.</p>
					<a
						href="https://realschools.com.au/books/restoring-teaching/ebook/thank-you"
						target="_blank"
						class="btn btn-small btn-navy"
						>Download here</a
					>
				</div>

				<div class="col col-4">
					<h4>Free audiobook</h4>
					<p>Restoring Teaching is available as a free audiobook.</p>
					<a
						href="https://realschools.com.au/books/restoring-teaching/audiobook/thank-you/"
						target="_blank"
						class="btn btn-small btn-navy"
						>Download here</a
					>
				</div>

				<div class="col col-4">
					<h4>Hard copy</h4>
					<p>Partner champions who would like additional hard copies of Restoring Teaching should discuss this with their Real Schools Expert Facilitator.</p>
				</div>
			</div>
		</section>
		<section class="container cols band">
			<div class="col col-2" />
			<div class="col col-8 col-center text-center">
				<h3>Study Guide</h3>
				<div>
					<a
						href="https://realschools.com.au/books/restoring-teaching/study-guide"
						target="_blank"
						class="btn btn-small btn-navy"
						>Download it now</a
					>
				</div>
			</div>
		</section>
	</div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import bookImage from '@/images/book.jpg';
import type { Resource } from '@/interfaces/resourceInterface';

export default defineComponent({
	props: {
		resource: {
			type: Object as PropType<Resource>,
			required: true,
		},
	},
	data() {
		return {
			bookImage,
		};
	},
});
</script>

<style scoped lang="scss">
#hero {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	margin: 0;
	background-color: rgb(var(--rs-color-brand-tomato));
	min-height: 300px;

	h1,
	h2,
	p {
		margin: 0;
		color: white;
	}

	h1 {
		margin-bottom: 20px;
	}

	h2 {
		margin: 20px 0 40px 0;
	}
}

#book {
	img {
		width: clamp(200px, 100%, 300px);
	}

	#book-details {
		background-color: #eaeef1;

		#free {
			margin: 40px 0;
		}
	}
}

#quote {
	background-color: rgb(var(--rs-color-brand-navy));
	color: white;

	h3 {
		color: rgb(var(--rs-color-brand-mustard));
	}
}

#options {
	background-color: rgb(var(--rs-color-brand-tomato));
	color: white;

	h2 {
		margin: 20px 0 60px 0;
		color: white;
	}

	h4 {
		color: white;
	}

	.btn {
		margin-top: 40px;
	}

	@media screen and (width >= 640px) {
		.col {
			padding: 0 30px;
		}
	}
}
</style>
